import React from 'react';
import PropTypes from 'prop-types';

import iconPause from './assets/images/icons/pause.svg';
import iconPlay from './assets/images/icons/play.svg';

const styles = require('./ButtonToggleAnimations.module.scss');

function ButtonToggleAnimations({
  children,
  ariaLabel,
  onClick,
  motionDisabled,
}) {
  // limit visibility of this component to certain pages
  const pages = [
    '/air',
    '/air/design',
    '/air/performance',
    '/air/connectivity',
    '/charging',
    '/air/specs',
  ];
  let visible = false;
  const pathIncludes = i => window.location.pathname.indexOf(i) > -1;
  pages.forEach(a => {
    if (pathIncludes(a)) visible = true;
  });
  if (visible == false) {
    return false;
  }
  // ---

  return (
    <button
      className={styles.button}
      type="button"
      aria-label={ariaLabel}
      onClick={onClick}
    >
      <span className={styles.iconWrapper} aria-hidden="true">
        {!motionDisabled && (
          <img className={styles.icon} src={iconPause} alt="pause" />
        )}
        {motionDisabled && (
          <img className={styles.icon} src={iconPlay} alt="play" />
        )}
      </span>
      <span className={styles.label}>{children}</span>
    </button>
  );
}

ButtonToggleAnimations.propTypes = {
  children: PropTypes.node,
  ariaLabel: PropTypes.string,
  motionDisabled: false,
};

ButtonToggleAnimations.propTypes = {
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node,
  ariaLabel: PropTypes.string,
  motionDisabled: PropTypes.bool,
};

export default ButtonToggleAnimations;
